export enum ColorScheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export const ColorSchemeLabel = {
  DARK: 'THEME.COLORMODE.DARK',
  LIGHT: 'THEME.COLORMODE.LIGHT',
};
